import { render, staticRenderFns } from "./Disciplines.vue?vue&type=template&id=66048eb6&scoped=true&"
import script from "./Disciplines.vue?vue&type=script&lang=js&"
export * from "./Disciplines.vue?vue&type=script&lang=js&"
import style0 from "./Disciplines.vue?vue&type=style&index=0&id=66048eb6&lang=scss&scoped=true&"
import style1 from "./Disciplines.vue?vue&type=style&index=1&id=66048eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66048eb6",
  null
  
)

export default component.exports